// extracted by mini-css-extract-plugin
export default {"tabBar":"TabBar_tabBar__ONiMI","icon":"TabBar_icon__ipmmm","right":"TabBar_right__y1OoC","title":"TabBar_title__GA+oq","checked":"TabBar_checked__vJWZ6"};